import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const BULK_UPDATE_USER_TASK = 'BULK_UPDATE_USER_TASK';


export const service = async (task) => {
  const options: object = {
    url:  "/Api/UserTasks/BulkUpdateUserTask" ,
    method: "POST",
    body: JSON.stringify(task),
    ...getDefaultOptions(),
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(BULK_UPDATE_USER_TASK, service, mock);
